import { render, staticRenderFns } from "./userInfo_schoolData.vue?vue&type=template&id=9c96e654&scoped=true&"
import script from "./userInfo_schoolData.vue?vue&type=script&lang=js&"
export * from "./userInfo_schoolData.vue?vue&type=script&lang=js&"
import style0 from "./userInfo_schoolData.vue?vue&type=style&index=0&id=9c96e654&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c96e654",
  null
  
)

export default component.exports